export default "__VITE_ASSET__BrQs_Ex7__"